const statusOf = (value) => String(value ?? "").trim().toUpperCase();

export function isHeadsTailsTableOnline(odds) {
  return ["OPEN", "ONLINE"].includes(statusOf(odds?.status));
}

export function getHeadsTailsMarketState(odds, now = Date.now()) {
  if (!odds) return { open: false, message: "Loading table…" };
  const status = statusOf(odds.status);
  if (!isHeadsTailsTableOnline(odds)) {
    return { open: false, message: ["SUSPEND", "SUSPENDED"].includes(status) ? "Betting suspended" : "Betting closed" };
  }
  if (odds.isEmpty === true || statusOf(odds.isEmpty) === "TRUE" || !Array.isArray(odds.markets) || !odds.markets.length) {
    return { open: false, message: "Waiting for market odds…" };
  }
  return { open: true, message: "Place your bets" };
}

export function isHeadsTailsRunnerActive(runner) {
  return ["ACTIVE", "ONLINE", "OPEN"].includes(statusOf(runner?.status)) && Number.isFinite(Number(runner?.back1)) && Number(runner.back1) > 1;
}

export function normalizeHeadsTailsMarkets(markets) {
  if (!Array.isArray(markets)) return [];
  return markets.filter((market) => market && typeof market === "object").map((market) => ({
    ...market,
    oddDetailsDTO: Array.isArray(market.oddDetailsDTO)
      ? market.oddDetailsDTO.filter((runner) => runner && typeof runner === "object")
      : [],
  }));
}
